import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const HistoryTabs = () => {
    const [activeTab, setActiveTab] = useState(0);
    const tabListRef = useRef(null);
    const navigate = useNavigate();

    const tabs = [
        { label: "1900-1970", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="blue">A bold investment in mass transit made modern New York possible.</h3>
                    <p className="p3">When New York became one of the first cities in the world to build a subway system in 1904, it was during a moment of profound transformation.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/b6f9a776-7598-437c-cff3-00b175820000/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">The advent of the subway enabled New Yorkers to spread out and reach jobs efficiently and safely, unleashing the development of new industries, opportunities, and neighborhoods and catapulting the New York region into the role of a leading global power. Between 1900 and 1950, as the subway system alone grew by 722 miles, the city's population more than doubled from 3.4 million to 7.9 million.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/8cb0f7fe-9a29-40b8-7d2e-d79739e1a300/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">But over the next two decades, the nation saw a rise in suburbanization and automobiles. The transit network that had powered generations of growth fell into decline.</p>
                </div>
            </div>
        )},
        { label: "1970s", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="red">By the 1970s, underinvestment brought the system&mdash;and the city&mdash;to the brink of collapse.</h3>
                    <p className="p3">Deferred maintenance and lack of funding meant that the whole system was at risk. Service deteriorated, and the New York City subways became an emblem of national decay. At the height of the transit crisis in 1983, on-time subway performance dropped below 50%.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/20a41f55-5b0f-4fd8-40ec-50e27c45fc00/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">With the implosion of the subways came the desertion of the city: New York's population plunged by almost 1 million people.</p>
                </div>
            </div>
        )},
        { label: "1980s", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="blue">An ambitious plan to restore the MTA's infrastructure reversed the decline and set New York on a new path to prosperity.</h3>
                    <p className="p3">In 1980, New York's leadership was bold enough to do something different. The MTA's first capital program, spearheaded by Chair Richard Ravitch, meant that, for the first time, the MTA's needs were systematically assessed and addressed.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/11746ab5-7ec4-4566-b34f-8aa1341cc300/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">The new program eradicated graffiti on railcars and stations, replaced or restored the entire subway fleet, brought 100% of subway track into good condition, renovated major stations, and purchased new rolling stock for the commuter rail lines.</p>
                    <p className="p3">And it worked. As on-time performance improved, ridership ultimately more than doubled&mdash;while the region gained 1.3 million jobs and 1.5 million residents.</p>
                </div>
            </div>
        )},
        { label: "2010s", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="red">But by the 2010s, we had forgotten the lessons of the 1980s.</h3>
                    <p className="p3">When the public crisis ended, the sense of political urgency went with it. Unfortunately, though progress had been made, the job was far from done.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/96b9546c-d7d2-4376-434c-3cee8b27e700/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">While the MTA made investments that were highly visible to riders, there were still significant amounts of work unfinished, including investments in "invisible infrastructure" such as power, maintenance shops, and train yards.</p>
                    <p className="p3">In the 2010s, the system was setting records for ridership&mdash;but it became clear that capital investment hadn't kept up. The system was strained, and service suffered.</p>
                    <p className="p3">By 2017, the hidden problems could be ignored no longer. In what was widely known as "the Summer of Hell," infrastructure began to break down. That year, New York's subway had the worst on-time performance of any major rapid transit system in the world. Just 65% of weekday trains reached their destinations on time, the lowest rate since the transit crisis of the 1970s.</p>
                </div>
            </div>
        )},
        { label: "2020s", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="blue">The most recent capital program was a historic investment, and the recent operating budget was another great step forward.</h3>
                    <p className="p3">New York rose to meet the crisis with the historic 2020-2024 Capital Program. Since then, the MTA and its revamped capital division have been building at a historic pace&mdash;and more cost-effectively than ever before.</p>
                    <p className="p3"><img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/21d5d4f5-5492-48da-3a2e-f6e9daec1100/width=2000" alt="" aria-hidden="true" /></p>
                    <p className="p3">We are grateful to the leadership shown by Gov. Kathy Hochul and the New York State Legislature for the recent operating budget, which recognized that transit was essential to New York and that cutting service was is an unacceptable option for the millions of New Yorkers who depend on transit every day.</p>
                    <p className="p3">This budget enabled us to maintain service levels&mdash;and even expand it in critical areas&mdash;by allowing us to retain workers, pay for utilities, and pay off debt.</p>
                    <p className="p3">But while service levels and personnel are essential, they depend on functioning systems to work. And there is a lot of work still to be done.</p>
                </div>
            </div>
        )},
        { label: "Today", content: (
            <div className="row">
                <div className="col-md-12">
                    <h3 className="red">Today we have a choice: Pick up the pace <span className="red">or risk falling behind again.</span></h3>
                    <p className="p3">Today, transit is playing a key role in the city's rebound from the pandemic&mdash;but continued success is far from assured.</p>
                    <p className="p3">The scale and age of the transit system&mdash;along with threats like climate change and priorities like accessibility&mdash;mean there's a lot more to do if we want to keep service trending in the right direction.</p>
                    <p className="p3">We can make the wrong choice again and watch the region's potential become choked by an aging system that cannot match the demands of a modern age.</p>
                    <p className="p3"><strong>Or we can break the cycle.</strong><br />
                        The MTA has spent the past two years analyzing every element of our system, which means we know where the problems are and what it will take to fix them.</p>
                    <p className="p3">This 20-Year Needs Assessment is the result. It allows us to plan holistically and proactively for the next 20 years, outlining a path toward a resilient, reliable, modern system that is safer, more efficient, and unlocks a new generation of prosperity.</p>
                    <p className="p3">It underscores the urgency of investing in our region's transportation network and outlines what capital investments are needed over the next 20 years to keep New York moving.</p>
                    <p className="p3"><a href="../#face-challenges" className="plus-sign" onClick={() => {
                        navigate('/#face-challenges');
                    }}>See our vision</a></p>
                </div>
            </div>
        )}
    ];

    useEffect(() => {
        const handleScroll = () => {
            const historyTabs = document.getElementById('history-tabs');
            const tabList = tabListRef.current;
            if (historyTabs && tabList) {
                const scrHt = window.scrollY -140;
                const tabsTop = historyTabs.getBoundingClientRect().top + window.scrollY -140;
                if (scrHt > tabsTop - 140) {
                    tabList.style.top = `${scrHt - tabsTop + 96}px`;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Trigger the scroll handler initially
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleTabClick = (index) => {
        setActiveTab(index);
        const historyTabs = document.getElementById('history-tabs');
        if (historyTabs) {
            window.scrollTo({
                top: historyTabs.getBoundingClientRect().top + window.scrollY - 140,
                behavior: 'smooth',
                duration: 800,
            });
        }
    };

    return (
        <div className="hdr-tabs has-js" id="history-tabs">
            <div className="hdr-tablist" role="tablist" ref={tabListRef}>
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className="hdr-tab"
                        type="button"
                        aria-selected={activeTab === index}
                        role="tab"
                        onClick={() => handleTabClick(index)}
                        tabIndex={activeTab === index ? 0 : -1}
                    >
                        <span>{tab.label}</span>
                    </button>
                ))}
            </div>

            {tabs.map((tab, index) => (
                <div
                    key={index}
                    className="hdr-tabpanel"
                    role="tabpanel"
                    aria-hidden={activeTab !== index}
                >
                    {tab.content}
                </div>
            ))}
        </div>
    );
};

export default HistoryTabs;
